import { BoxInner, TextBox } from "style/admin/layout";
import { fetchUpdateReviewCommentHide } from "api/admin/review";

interface ModalProps {
  closedHandler: () => void;
  reviewCommentId: number;
  isHideState: "Y" | "N";
}

const modalTxt = `모든 고객이 해당 글을 다시 볼 수 있게 됩니다.
글을 작성한 고객에게는 글 숨김해제 및 재노출 소식이 푸시 알림으로 발송됩니다.`;

const ShowConfirmModal = ({
  closedHandler,
  isHideState,
  reviewCommentId,
}: ModalProps) => {
  const showClickHandler = async (reviewId: number, hideYn: "Y" | "N") => {
    const yn = hideYn === "Y" ? "N" : "Y";
    try {
      const response = await fetchUpdateReviewCommentHide(reviewId, yn, "");
      if (response.result) closedHandler();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <BoxInner>
      <TextBox style={{ minHeight: "auto" }}>
        <p>글을 다시 노출하시겠습니까?</p>
        <span>{modalTxt}</span>
      </TextBox>
      <div className="btn-box">
        <button className="continue" onClick={closedHandler} type="button">
          돌아가기
        </button>
        <span></span>
        <button
          className="del"
          onClick={() => showClickHandler(reviewCommentId, isHideState)}
        >
          글 노출하기
        </button>
      </div>
    </BoxInner>
  );
};

export default ShowConfirmModal;
